import React, {Fragment} from 'react';
import ContentLoader from "react-content-loader"
import {Link} from 'react-router-dom';

import Avatar from '../../Avatar';
import Icon from '../../Icon';
import Dropdown from '../../Dropdown';
import {SpinLoader} from '../../Loader';
import {bindActionCreators} from "redux";
import {resetUserFriend, updateUserFriend} from "../../../../creators/user.friend";
import {connect} from "react-redux";
import createLink from "../../../../libs/createLink";
import Alert from "../../Alert";
import Modal from "../../Modal";
import {isNoFollowProfil} from "../../../../libs/helper";


class ManageFriend extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleAlertIgnore: false,
            toggleAlertDeleteFriend: false,
            isFavourite: this.props.isFavourite,
            loading : false
        };
        this.handleFavorite = this.handleFavorite.bind(this);
        this.handleAlertDeleteFriend = this.handleAlertDeleteFriend.bind(this);
    }

    componentWillUnmount() {
        this.setState({isFavourite: false, friendId: 0});
    }

    handleFavorite() {
        this.setState({isFavourite: !this.state.isFavourite, friendId: this.props._id, loading : true});
        this.props.updateUserFriend(this.props.userId, this.props._id).then(response=>{
            this.setState({isFavourite : response.payload.favourite, loading : false})
        }).catch(error =>{
            this.setState({isFavourite : !this.state.isFavourite, loading : false})
        });
    }

    handleAlertDeleteFriend(){
        this.props.handleRemoveFriend(this.props._id);
        this.setState({toggleAlertDeleteFriend: false});
    }

    render() {
        let user = this.props.author ? this.props.author : this.props;
        let relLinkProfil = {};
        if(this.props.userFriendsInitialized){
            relLinkProfil = isNoFollowProfil(user) ? { rel: "nofollow" } : {};
        }
        return (
            <Fragment>
                {!this.props.userFriendsInitialized ? (
                    <ContentLoader
                        ariaLabel={false}
                        height={60}
                        width={260}
                        speed={2}
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="72" y="17" rx="4" ry="4" width="117" height="6.4"/>
                        <rect x="72" y="37" rx="3" ry="3" width="85" height="6.4"/>
                        <circle cx="29.4" cy="29.81" r="26.4"/>
                        <rect x="257.78" y="40.61" rx="0" ry="0" width="0" height="0"/>
                        <circle cx="247.8" cy="28.63" r="8.02"/>
                    </ContentLoader>
                ) : (
                    <div className="friends">
                        <Link to={createLink('userProfile', user)} {...relLinkProfil}>
                            <Avatar avatar={user.profile && (user.profile.avatar || "")}
                                    gender={user.profile && user.profile.gender} alt=""/>
                        </Link>
                        <div className="infos-user-wrapper">
                            <Link to={createLink('userProfile', user)} {...relLinkProfil}>
                                <div className="username">{user.username || ""}</div>
                            </Link>
                        </div>
                        {this.props.isMe && (
                            <div className="options">
                                {this.state.loading ? (
                                    <SpinLoader className={"small"}/>
                                ) : (
                                    <span onClick={() => this.handleFavorite()}>
                                        {this.state.isFavourite ? (
                                            <Icon type="star-full"/>
                                        ) : (
                                            <Icon type="star-empty"/>
                                        )}
                                    </span>
                                )}

                                <Dropdown align="right" activableComponent={(
                                    <Icon type="vertical-dots"/>
                                )}>
                                    <ul className="dropdown-menu">
                                        <li className="menu-item"
                                            onClick={() => this.setState({toggleAlertDeleteFriend: true})}>
                                            <Icon type="close"/>Retirer de mes amis
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                        )}
                    </div>
                )}
                <Modal toggle={this.state.toggleAlertDeleteFriend} handleClose={()=>this.setState({toggleAlertDeleteFriend: false})}>
                    <Alert handleClose={() => this.setState({toggleAlertDeleteFriend: false})}
                           handleDelete={this.handleAlertDeleteFriend}
                           text="Voulez-vous vraiment supprimer cette personne de vos ami(e)s?"/>
                </Modal>
            </Fragment>
        )
    }
}

ManageFriend.defaultProps = {
    _id: 0,
    slug: '',
    username: '',
    profile: {avatar: "", gender: "0"},
};


const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetUserFriend,
    updateUserFriend,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ManageFriend);
